import styles from '../../assets/styles/Login/Login.module.scss';
import React from 'react';
import SliderImg1 from '../../assets/img/Mimaweb.png';

import { useMediaQuery } from 'react-responsive';
import { mimaPayLogo } from '../../assets';

function LeftSide(props) {
	const isBelow900 = useMediaQuery({
		query: '(max-width: 900px)',
	});
	const isBelow500 = useMediaQuery({
		query: '(max-width: 500px)',
	});

	const goToLanding = () => {
		window.open('https://mimapay.africa');
	};

	return (
		<div className={styles.leftside}>
			<img
				src={mimaPayLogo}
				className={styles.logo}
				onClick={goToLanding}
				alt="Logo"
			/>
			<div className={styles.slider}>
				{!isBelow500 && (
					<img src={SliderImg1} className={styles.slider__img} alt="Mima pay" />
				)}
				<h3 className={styles.slider__title}>{props.title}</h3>
				{!isBelow900 && (
					<div className={styles.slider__p}>
						At mima pay we are commited to empowering businesses with seamless
						tools for invoicing, payments, bookings, subscriptions, and website
						creation. Simplify operations, expand globally with multicurrency
						support, and grow your brand—all from one platform.{' '}
						<span className={styles.color__primary}>
							Start using Mimapay today.
						</span>
					</div>
				)}
				{!isBelow900 && (
					<div className={styles.slider__icon}>
						<div className={styles.slider__icon__default}></div>
						<div className={styles.slider__icon__outline}></div>
						<div className={styles.slider__icon__outline}></div>
					</div>
				)}
			</div>
		</div>
	);
}

export default LeftSide;
